import {useCallback, useEffect, useState} from "react";
import {getCookie, getParameterByName} from "../utils.js";
import {appConfig} from "../config";

export const useSafeRedirect = ({
                                    redirectSearchParamName = 'redirect',
                                    redirectCookieName = 'cs_redirect'
                                } = {}) => {
    const [validatedRedirect, setValidatedRedirect] = useState(null);

    useEffect(() => {
        const cookieValue = getCookie(redirectCookieName);
        const parameterValue = getParameterByName(redirectSearchParamName);
        const validatedParameterValue = appConfig.allowedRedirects.test(parameterValue) ? parameterValue : null;
        const targetRedirect = validatedParameterValue || cookieValue;

        setValidatedRedirect(targetRedirect);

        const expireTime = new Date(Date.now() + 120 * 60000);

        if (validatedParameterValue && !validatedParameterValue.startsWith(window.location.origin))
            document.cookie = `${redirectCookieName}=` + targetRedirect + ";path=/;expires=" + expireTime.toUTCString();
    }, [redirectCookieName, redirectSearchParamName]);

    // I unfortunately don't have a better name for this...
    const legacyRedirect = useCallback((originalUri = null) => {
        let redirect = null;

        const tempRedirect = getParameterByName('redirect');

        if (tempRedirect && !tempRedirect.startsWith(window.location.origin)) redirect = tempRedirect;

        const newURI = redirect || originalUri || getCookie("cs_redirect");

        return !appConfig.allowedRedirects.test(newURI)
            ? appConfig.defaultRedirectTo
            : newURI;
    }, []);

    return {validatedRedirect, legacyRedirect}
};
